import React, { useContext } from "react";
import "../../styles/homepage.css";
import Capsule from "../common/Capsule";
import { WebsiteContext } from "../../context/AppContext";
import appImage from "../../images/mainImage.webp";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import lottie1 from "../../lottie/lottie1.json";
import lottie2 from "../../lottie/lottie2.json";
import { FaGooglePlay } from "react-icons/fa6";
import "animate.css";

const FirstSection = () => {
  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 100,
    duration: 3,
  };

  const { isMobileView, dark, handleRoute } = useContext(WebsiteContext);
  //console.log("isMobileView", isMobileView);
  return (
    <div className="first_section_container">
      <div className="heading">
        {dark ? (
          <Lottie animationData={lottie2} loop={false} rel="preload"/>
        ) : (
          <Lottie animationData={lottie1} loop={false} rel="preload"/>
        )}
      </div>
      <h1
        className={
          isMobileView
            ? "animate__animated animate__flipInX sub_heading_mobile"
            : "animate__animated animate__flipInX sub_heading"
        }
      >
        "Fluency is not a destination but a journey, and every practice brings
        you closer to your goal".
      </h1>
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={spring}
        className="app_new_image"
      >
        <img src={appImage} alt="appImage"  fetchPriority="high"/>
      </motion.div>

      <div className="hero_cta_wrap">
        <button
          className="hero_download_btn"
          onClick={() => handleRoute("GettheApp")}
        >
          <FaGooglePlay size={16} />
          <span>Get Fluent Fable on Google Play</span>
        </button>
      </div>
      {isMobileView ? (
        <div className="content_mobile">
          <Capsule title={"Spoken English"} image={"spoken_english"} />
          <Capsule title={"Basic to Advance English"} image={"pdf"} />
          <Capsule title={"Daily AI Insights"} image={"ai_insights"} />
          <Capsule title={"Vocab & Grammar Quiz"} image={"quiz"} />
          <Capsule title={"AI English Practice"} image={"ai_practice"} />
          <Capsule title={"AI Learning Path"} image={"learning_path"} />
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={spring}
          className="content"
        >
          <Capsule title={"Spoken English"} image={"spoken_english"} />
          <Capsule title={"Basic to Advance English"} image={"pdf"} />
          <Capsule title={"Daily AI Insights"} image={"ai_insights"} />
          <Capsule title={"Vocab & Grammar Quiz"} image={"quiz"} />
          <Capsule title={"AI English Practice"} image={"ai_practice"} />
          <Capsule title={"AI Learning Path"} image={"learning_path"} />
        </motion.div>
      )}
    </div>
  );
};

export default FirstSection;
